(function() {
  'use strict';

  angular
    .module('newDocument.boxDocumentDirective', [])
    .directive('mfBoxDocument', mfBoxDocument);

  mfBoxDocument.$inject = [];

  function mfBoxDocument() {
    return {
      link: function(scope, element) {
        var outer = $('#slideOuter');
        if (scope.narrationTemplate)
          outer.addClass('crocodocNarration');

        scope.$on('$destroy', function() {
          outer.removeClass('crocodocNarration');
        });
      }
    };
  }
})();
